import React from 'react';
import type { Tile } from '../../types/mjai';
import TileImage from './TileImage';

const TILE_GROUPS: { label: string; tiles: Tile[] }[] = [
  {
    label: '萬子',
    tiles: ['1m','2m','3m','4m','0m','5m','6m','7m','8m','9m'],
  },
  {
    label: '筒子',
    tiles: ['1p','2p','3p','4p','0p','5p','6p','7p','8p','9p'],
  },
  {
    label: '索子',
    tiles: ['1s','2s','3s','4s','0s','5s','6s','7s','8s','9s'],
  },
  {
    label: '字牌',
    tiles: ['1z','2z','3z','4z','5z','6z','7z'],
  },
];

interface TileSelectorProps {
  onSelect: (tile: Tile) => void;
  selectedTile?: Tile;
  disabledTiles?: Set<string>;
}

export default function TileSelector({ onSelect, selectedTile, disabledTiles }: TileSelectorProps) {
  return (
    <div className="space-y-2 p-3 bg-green-50 rounded-lg border border-green-100">
      {TILE_GROUPS.map((group) => (
        <div key={group.label}>
          <div className="text-xs text-green-700 mb-1">{group.label}</div>
          <div className="flex flex-wrap gap-1">
            {group.tiles.map((tile) => (
              <TileImage
                key={tile}
                tile={tile}
                size="sm"
                selected={selectedTile === tile}
                onClick={() => onSelect(tile)}
                disabled={disabledTiles?.has(tile)}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
